import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService }                    from '@ngx-translate/core';
import { UIRouter }                            from '@uirouter/core';
import { Subscription }                        from 'rxjs';

import { CodeTypeModel }                       from '../../core/models/code-type';
import { Table }                               from '../../table/types/table';
import { TableQueryParameters }                from '../../table/types/table-query-parameters';
import { TableService }                        from '../../table/table.service';
import { TransactionCenterFiltersModel }       from '../typings/transaction-center.filters';
import { TransactionCenterInspectionModel }    from './typings/transaction-center.inspection';
import { TransactionCenterInspectionsService } from './transaction-center.inspections.service';
import { TransactionCenterService }            from '../transaction-center.service';

@Component({
  selector   : 'wor-transaction-center-inspections',
  template: require('./transaction-center.inspections.component.html')
})
export class TransactionCenterInspectionsComponent implements OnDestroy, OnInit {
  @Input() inspections: Array<TransactionCenterInspectionModel> = [];
  @Input() statuses   : Array<CodeTypeModel>                    = [];

  broadcastKey  = this.inspectionsService.broadcastKey;
  tableCacheKey = this.inspectionsService.tableCacheKey;

  filters : TransactionCenterFiltersModel = this.tableService.setFiltersFromCache(this.tableCacheKey, {
    status: 'D',
    value : ''
  });

  tableSettings : Table = {
    broadcast: this.broadcastKey,
    cache    : {
      enabled: true,
      key    : this.tableCacheKey
    },
    columns: this.inspectionsService.buildColumns(this.filters),
    empty  : {
      text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INSPECTIONS_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : this.tableService.getCachedPaging(this.tableCacheKey).pageSize || 10,
      pageSizes : [ 10, 25, 50 ],
      queryCount: () => this.inspectionsService.getCount(this.filters)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: this.tableService.setSortingFromCache(this.tableCacheKey, {
      direction: 'desc',
      field    : 'inspection_date'
    })
  };

  searchSubscription: Subscription;

  constructor (
    private inspectionsService      : TransactionCenterInspectionsService,
    private router                  : UIRouter,
    private tableService            : TableService,
    private transactionCenterService: TransactionCenterService,
    private translateService        : TranslateService
  ) {}

  ngOnDestroy () : void {
    this.searchSubscription?.unsubscribe();
  }

  ngOnInit () : void {
    this.transactionCenterService.setSearch(this.filters.value || '');

    this.searchSubscription = this.transactionCenterService.searchChanges
      .subscribe(value => {
        if ( value !== null && value !== this.filters.value ) {
          this.filters.value = value;

          this.filterTable();
        }
      });
  }

  filterTable ( updateColumns = false ) : void {
    if ( updateColumns ) {
      this.tableSettings = this.inspectionsService.getUpdatedColumns(this.tableSettings, this.filters);
    }

    if ( window[ this.broadcastKey ] ) {
      window[ this.broadcastKey ](this.filters);
    }
  }

  getInspections ( params : TableQueryParameters ) : Promise<Array<TransactionCenterInspectionModel>> {
    return this.inspectionsService.get(this.filters, params)
      .then(( inspections : Array<TransactionCenterInspectionModel> ) => {
        this.inspections = inspections;

        return inspections;
      });
  }

  viewInspection ( inspection : TransactionCenterInspectionModel ) : void {
    this.router.stateService.go('app.inspection', {
      customer_id: inspection.customer_id,
      id         : inspection.id,
      vehicle_id : inspection.vehicle_id
    });
  }
}
